import React from "react"
import Navbar from "../../components/Navbar"
import DashboardContainer from "../Dashboard/DashboardContainer"
import UserImg from "../../assets/Images/tempImg/user.png"
import Card from "../../components/Card"
import EditButton from "../../components/Buttons/EditButton"
import ProfileCard from "../../components/Profile/ProfileCard"
import Headings from "../../components/Texts/Headings"
import { InfoContainer } from "./component/InfoContainer"

const EKyc = () => {
  const userDetails = {
    name: "Vikram Das",
    pan: "124VDFFFF4G",
    pincode: "400701",
    dob: "12/12/1990",
    gender: "Male",
    email: "vikramdas@gmail.com",
    phone: "+91 8422005522",
    aadhar: "1234 5678 9012",
    address: "Keshav Kunj, sector 26, Vashi, Navi Mumbai, Maharashtra",
  }
  const { name, aadhar, address, pincode, email, phone } = userDetails
  return (
    <>
      <Navbar isLoggedIn={true} />
      <DashboardContainer>
        <Headings
          text=" E- KYC"
        />
        <ProfileCard
          UserImg={UserImg}
          name={name}
          docTitle={"Aadhar Card Number"}
          doc={aadhar}
        />
        <Card className="mt-[18px] max-w-[100%] md:max-w-[70%]">
          <div className="flex flex-col gap-[18px] ">
            <InfoContainer title="Name" value={name} />
            <InfoContainer title="Address" value={address} />
            <InfoContainer title="Pin Code" value={pincode} />
          </div>
        </Card>

      </DashboardContainer>
    </>
  )
}

export default EKyc
